import React, { useEffect, useState } from 'react'; 
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import CenterModal from 'components/presenters/modal/CenterModal';
import SurveyIntro from 'components/containers/matching/survey/SurveyIntro';
import SurveyStart from 'components/containers/matching/survey/SurveyStart';
import SurveyMultiSelector from 'components/containers/matching/survey/SurveyMultiSelector';
import SurveyLocation from 'components/containers/matching/survey/SurveyLocation';
import SurveyEnd from 'components/containers/matching/survey/SurveyEnd';
import server from 'server/serverController2';

export default function MatchingProfileSurvey({setOnBackBtn}) {
  const userInfo = useSelector((state) => {
    return state.userInfo;
  });
  const history = useHistory();

  const [locationList, setLocationList] = useState([]); 
  const [mbtiList, setMbtiList] = useState([]);
  const [interestList, setInterestList] = useState([]);
  const [activityList, setActivityList] = useState([]);

  const [surveySceneStep, setSurveySceneStep] = useState(null);
  const [selectedInterest, setSelectedInterest] = useState([]);
  const [selectedActivity, setSelectedActivity] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [selectedMBTI, setSelectedMBTI] = useState([]);

  //Center Modal State
  const [initCenterModal, setInitCenterModal] = useState(false);
  const [centerModalVisible, setCenterModalVisible] = useState(false);
  const [centerModalDataList, setCenterModalDataList] = useState({});
  const [onModalComplete, setOnModalComplete] = useState(null);
  const [onModalCancel, setOnModalCancel] = useState(null);
  
  const [isSubmitting, setIsSubmitting] = useState(false);
  //Init Center Modal State
  useEffect(()=>{
    if(initCenterModal === true)
    {
      setCenterModalVisible(false);
      setCenterModalDataList({})
      setOnModalComplete(null);
      setOnModalCancel(null);
      setInitCenterModal(false);
    }
  }, [initCenterModal])

  //receive data
  useEffect(()=>{
    let getInitData = async () => {

      server.getRequestData('matching/category/location?parent_no=1',(res)=>{
        if(res.success === 0)
        {
          return;
        }

        let jsonData = res.data;
        setLocationList(jsonData['locations']);
      });

      server.getRequestData('matching/category/mbti',(res)=>{
        if(res.success === 0)
        {
          return;
        }

        let jsonData = res.data;
        setMbtiList(jsonData['mbtis']);
      });
      server.getRequestData('matching/category/interest',(res)=>{
        if(res.success === 0)
        {
          return;
        }

        let jsonData = res.data;
        setInterestList(jsonData['interests']);
      });
      server.getRequestData('matching/category/activity',(res)=>{
        if(res.success === 0)
        {
          return;
        }

        let jsonData = res.data;
        setActivityList(jsonData['activities']);
      });
    }
    if(userInfo['isLogin'])
    {
      getInitData();
    }
    else
    {
      setCenterModalVisible(true);
      setCenterModalDataList({description:"로그인이 필요한 서비스입니다."});
      setOnModalComplete(()=>()=>{
        setInitCenterModal(true);
        history.replace('/social');
      })
    }
  },[])

  /* eslint-disable react-hooks/exhaustive-deps */ 
  useEffect(()=>{
    if([null, undefined, 0].includes(surveySceneStep))
    {
      setOnBackBtn(null);
    }
    else if(surveySceneStep === 1)
    {
      setOnBackBtn(()=>()=>{
        setSurveySceneStep(0);
      });
    }
    else if(surveySceneStep === 2)
    {
      setOnBackBtn(()=>()=>{
        setSurveySceneStep(1);
      });
    }
    else if(surveySceneStep === 3)
    {
      setOnBackBtn(()=>()=>{
        setSurveySceneStep(2);
      });
    }
    else if(surveySceneStep === 4)
    {
      setOnBackBtn(()=>()=>{
        setSurveySceneStep(3);
      });
    }
    else if(surveySceneStep === 5)
    {
      setOnBackBtn(()=>()=>{
        setSurveySceneStep(4);
      });
    }
    else if(surveySceneStep === 6)
    {
      setOnBackBtn(()=>()=>{
        setSurveySceneStep(5);
      });
    }
  },[surveySceneStep])

  const submitResult = () => {
    if(isSubmitting === false)
    {
      setIsSubmitting(true);
      let form = null;
      server.getRequestData('matching/profile', (res)=>{
        form = {};
        form['activity_no'] = selectedActivity;
        form['interest_no'] = selectedInterest;
        form['mbti_no'] = selectedMBTI[0];
        form['location_no'] = [selectedLocation['no']];

        if(res.success === 0)
        {
          if(res['error']['res_data']['detail_code'] === "MATCHING_PROFILE_DOES_NOT_EXIST")
          {
            server.postRequestData('matching/profile',form, (res)=>{
              setIsSubmitting(false);
            })
            return;
          }
        }
        form['profile_no'] = res['data']['no'];
        server.putRequestData('matching/profile',form, (res)=>{
          setIsSubmitting(false);
        })
      })
    }
  }

  const surveyScene = () => {
    if([null, undefined, 0].includes(surveySceneStep))
    {
      return (
        <SurveyIntro onComplete={()=>{
          setSurveySceneStep(1);
        }}/>
      );
    }
    else if(surveySceneStep === 1)
    {
      return(
        <SurveyStart onComplete={()=>{
          setSurveySceneStep(2);
        }}/>
      );
    }
    else if(surveySceneStep === 2)
    {
      return(
        <SurveyMultiSelector 
          onComplete={()=>{
            setSurveySceneStep(3);
          }}
          title={(<>현재 관심있는<br />분야는 무었인가요?</>)}
          description={`쵀대 3개 선택해 주세요.`}
          items={interestList}
          setSelectedItems={setSelectedInterest}
          selectedItems={selectedInterest}
          maxReq={3}
          minReq={1}
        />
      );
    }
    else if(surveySceneStep === 3)
    {
      return(
        <SurveyMultiSelector 
          onComplete={()=>{
            setSurveySceneStep(4);
          }}
          title={(<>함께 하고싶은<br />자기계발 활동은 무엇인가요?</>)}
          description={`1개 선택해 주세요`}
          items={activityList}
          setSelectedItems={setSelectedActivity}
          selectedItems={selectedActivity}
          maxReq={1}
          minReq={1}
          replace={true}
        />
      );
    }
    else if(surveySceneStep === 4)
    {
      return(<SurveyLocation 
          items={locationList}
          setSelectedLocation={setSelectedLocation}
          selectedLocation={selectedLocation}
          onComplete={()=>{
            setSurveySceneStep(5);
          }}
        />)
    }
    else if(surveySceneStep === 5)
    {
      return(
        <SurveyMultiSelector 
          colNum={4}
          onComplete={()=>{
            submitResult();
            setSurveySceneStep(6);
          }}
          title={(<>{userInfo['name']}님의 MBTI는<br />무엇인가요?</>)}
          items={mbtiList}
          setSelectedItems={setSelectedMBTI}
          selectedItems={selectedMBTI}
          maxReq={1}
          minReq={1}
          replace={true}
        />
      )
    }
    else if(surveySceneStep === 6)
    {
      return (<SurveyEnd onComplete={()=>{
        history.replace('/matching')
      }}/>);
    }
  }
  return (
    <>
      <div>
      {surveyScene()}
      </div>
      <CenterModal modalVisible={centerModalVisible} setModalVisible={setCenterModalVisible} dataList={centerModalDataList} onCancel={onModalCancel} onComplete={onModalComplete}/>
    </>
  );
}
